import React from 'react';

import cn from '~/Utils/cn';

import { useMiniDrawer } from './MiniDrawerContext';
import type { MiniDrawerSectionProps } from './types';

const MiniDrawerSection: React.FC<MiniDrawerSectionProps> = ({ title, children, className, titleClassName }) => {
  const { isExpanded, transitionDuration } = useMiniDrawer();

  return (
    <div className={cn('flex flex-col', className)}>
      {title && (
        <div
          className={cn(
            'overflow-hidden whitespace-nowrap px-20 py-8 text-xs font-semibold uppercase tracking-wider opacity-60 transition-opacity',
            { 'h-0 py-0 opacity-0': !isExpanded },
            titleClassName
          )}
          style={{ transitionDuration: `${transitionDuration}ms` }}
        >
          {title}
        </div>
      )}
      {children}
    </div>
  );
};

export default MiniDrawerSection;
